import Immutable from 'seamless-immutable';

import { createReducer, createActions } from 'reduxsauce';

export const { Types, Creators } = createActions({
  checkoutRequest: ['cid', 'validCart', 'cartData', 'ctx'],
  checkoutSuccess: ['data'],
  checkoutFailed: ['error'],

  checkoutAddressRequest: ['address', 'noCalcFreight'],
  checkoutAddressSuccess: [],
  checkoutAddressFailed: ['error'],

  getPaymentTypesRequest: ['cartId'],
  getPaymentTypesSuccess: ['data'],
  getPaymentTypesError: ['error'],

  selectPaymentRequest: ['data'],
  selectPaymentSuccess: ['data'],
  selectPaymentError: ['error'],

  removePaymentRequest: [],

  selectFinancingRequest: ['data'],
  selectFinancingSuccess: ['data'],
  selectFinancingError: ['error'],

  sendPaymentRequest: [],
  sendPaymentSuccess: ['data'],
  sendPaymentError: ['error'],

  confirmationRequest: ['cartId'],
  confirmationSuccess: ['data'],
  confirmationError: ['error'],

  createBilletRequest: ['seller'],
  createBilletSuccess: ['sellerId', 'billet'],
  createBilletError: ['error'],

  pixPaymentRequest: ['seller'],
  pixPaymentSuccess: ['sellerId', 'data'],
  pixPaymentError: ['sellerId', 'error'],

  clearBilletRequest: ['sellerId'],

  location: ['data'],
});

const INITIAL_STATE = Immutable({
  addressDelivery: {},
  confirmPaymentOrder: {},
  confirmation: {},
  creditCard: {},
  creditCards: {},
  data: {},
  deliveryAddresses: [],
  error: {},
  financing: {},
  isLoading: false,
  payment: {},
  payments: [],
  location: {},
});

const userLocation = (state = INITIAL_STATE, { data }) => state.merge({ location: data });

const checkoutRequest = (state = INITIAL_STATE) => state.merge({ isLoading: true, error: {} });

const checkoutSuccess = (state = INITIAL_STATE, { data }) => {
  const { addresses, deliveryAddresses } = data;

  const addressDelivery =
    deliveryAddresses.find((deliveryAddress) => addresses.find((address) => address.id === deliveryAddress.address.id))
      ?.address || {};

  return state.merge({ ...data, addressDelivery, isLoading: false });
};

const checkoutError = (state = INITIAL_STATE, { error }) => state.merge({ error, isLoading: false });

const checkoutAddressRequest = (state = INITIAL_STATE) => state.merge({ isLoading: true });

const checkoutAddressSuccess = (state = INITIAL_STATE) => state;

const getPaymentTypesSuccess = (state = INITIAL_STATE, { data }) => state.merge(data);
const getPaymentTypesError = (state = INITIAL_STATE, { error }) => state.set('error', error);

const selectPaymentSuccess = (state = INITIAL_STATE, { data }) => state.merge(data);
const selectPaymentError = (state = INITIAL_STATE, { error }) => state.set('error', error);

const removePaymentRequest = (state = INITIAL_STATE) => state.set('payment', {});

const selectFinancingSuccess = (state = INITIAL_STATE, { data }) => state.merge(data);
const selectFinancingError = (state = INITIAL_STATE, { error }) => state.set('error', error);

const sendPaymentRequest = (state = INITIAL_STATE) =>
  state.merge({ error: {}, confirmPaymentOrder: {}, isLoading: true });

const sendPaymentSuccess = (state = INITIAL_STATE, { data }) => state.merge(data).set('isLoading', true);
const sendPaymentError = (state = INITIAL_STATE, { error }) => state.merge({ error }).set('isLoading', false);

const confirmationRequest = (state = INITIAL_STATE) => state.merge({ isLoading: true, error: {} });

const confirmationSuccess = (state = INITIAL_STATE, { data }) =>
  state.merge({ confirmation: { ...state.getIn(['confirmation']), ...data }, isLoading: false });

const confirmationError = (state = INITIAL_STATE, { error }) => state.merge({ error, isLoading: false });

const createBilletRequest = (state = INITIAL_STATE) =>
  state.setIn(['confirmation', 'isLoading'], true).set('error', {});

const createBilletSuccess = (state = INITIAL_STATE, { billet, sellerId }) => {
  const index = state
    .getIn(['confirmation', 'sellers'])
    .findIndex((seller) => seller.getIn(['seller', 'id']) === sellerId);

  return state.setIn(['confirmation', 'isLoading'], false).setIn(['confirmation', 'sellers', index, 'billet'], billet);
};

const createBilletError = (state = INITIAL_STATE, { error }) =>
  state.setIn(['confirmation', 'isLoading'], false).set('error', error);

const clearBilletRequest = (state = INITIAL_STATE, { sellerId }) => {
  const index = state
    .getIn(['confirmation', 'sellers'])
    .findIndex((seller) => seller.getIn(['seller', 'id']) === sellerId);

  return state.setIn(['confirmation', 'sellers', index, 'billet'], null);
};

const pixPaymentSuccess = (state = INITIAL_STATE, { data, sellerId }) =>
  state.setIn(['confirmation', 'pix', sellerId], data).set('isLoading', false);

const pixPaymentError = (state = INITIAL_STATE, { error, sellerId }) =>
  state.setIn(['confirmation', 'pix', sellerId], { error }).set('isLoading', false);

export default createReducer(INITIAL_STATE, {
  [Types.CHECKOUT_REQUEST]: checkoutRequest,
  [Types.CHECKOUT_SUCCESS]: checkoutSuccess,
  [Types.CHECKOUT_FAILED]: checkoutError,

  [Types.CHECKOUT_ADDRESS_REQUEST]: checkoutAddressRequest,
  [Types.CHECKOUT_ADDRESS_SUCCESS]: checkoutAddressSuccess,
  [Types.CHECKOUT_ADDRESS_FAILED]: checkoutError,

  [Types.GET_PAYMENT_TYPES_SUCCESS]: getPaymentTypesSuccess,
  [Types.GET_PAYMENT_TYPES_ERROR]: getPaymentTypesError,

  [Types.SELECT_PAYMENT_SUCCESS]: selectPaymentSuccess,
  [Types.SELECT_PAYMENT_ERROR]: selectPaymentError,

  [Types.REMOVE_PAYMENT_REQUEST]: removePaymentRequest,

  [Types.SELECT_FINANCING_SUCCESS]: selectFinancingSuccess,
  [Types.SELECT_FINANCING_ERROR]: selectFinancingError,

  [Types.SEND_PAYMENT_REQUEST]: sendPaymentRequest,
  [Types.SEND_PAYMENT_SUCCESS]: sendPaymentSuccess,
  [Types.SEND_PAYMENT_ERROR]: sendPaymentError,

  [Types.CONFIRMATION_REQUEST]: confirmationRequest,
  [Types.CONFIRMATION_SUCCESS]: confirmationSuccess,
  [Types.CONFIRMATION_ERROR]: confirmationError,

  [Types.CREATE_BILLET_REQUEST]: createBilletRequest,
  [Types.CREATE_BILLET_SUCCESS]: createBilletSuccess,
  [Types.CREATE_BILLET_ERROR]: createBilletError,

  [Types.PIX_PAYMENT_REQUEST]: checkoutRequest,
  [Types.PIX_PAYMENT_SUCCESS]: pixPaymentSuccess,
  [Types.PIX_PAYMENT_ERROR]: pixPaymentError,

  [Types.CLEAR_BILLET_REQUEST]: clearBilletRequest,
  [Types.LOCATION]: userLocation,
});
